import script from "./supPage.vue?vue&type=script&setup=true&lang=js"
export * from "./supPage.vue?vue&type=script&setup=true&lang=js"

import "./supPage.vue?vue&type=style&index=0&id=49a6a23e&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a6a23e"]])

export default __exports__